class AnimationSubsArbitraryCols {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleSubsArbitraryCols = this.sectionsContainer.querySelectorAll('.subs-arbitrary-cols');
		
		if (!this.$moduleSubsArbitraryCols.length)
			return;
		
		this.$moduleSubsArbitraryColsElements = [];
		this.$moduleSubsArbitraryCols.forEach(module => {
			this.$moduleSubsArbitraryColsElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleSubsArbitraryCols.forEach((module, index) => {
		    console.log(this.$moduleSubsArbitraryColsElements[index])
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleSubsArbitraryColsElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		const moduleSubsArbitraryCols = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleSubsArbitraryCols[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleSubsArbitraryColsElements[index], { clearProps: true });
			}
        });

        moduleSubsArbitraryCols.addLabel('step1');
        moduleSubsArbitraryCols.to(this.$moduleSubsArbitraryCols[index], { opacity: 1, duration: 1 }, 'step1');
		moduleSubsArbitraryCols.to(this.$moduleSubsArbitraryColsElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationSubsArbitraryCols;
